var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon',{staticClass:"drag-cursor",attrs:{"color":"mediumTwo"}},[_vm._v("drag_handle")])}
var staticRenderFns = []

export { render, staticRenderFns }